<script>
import CustomerRequest from 'Domain/customers/CustomerRequest';
import ReportManagerDialogVue from 'Support/components/modals/ReportManagerDialog.vue';

export default {
  name: 'CustomersTerminatteButton',
  extends: ReportManagerDialogVue,
  data: () => ({
    requestClass: CustomerRequest,
    buttonLabel: 'Baixar clientes',
    tableName: 'CustomersCrudList',
  }),
};
</script>
